<button mat-mini-fab [matMenuTriggerFor]="menu" color="primary" aria-label="Notification">
  <mat-icon>notifications</mat-icon>
  <div class="dot_count" *ngIf="unreadNotificationCount$ | async as count">
    {{ count }}
  </div>
</button>

<mat-menu #menu="matMenu" [class]="'custom-menu'" yPosition="above">
  <div (click)="$event.stopPropagation();">
    <!-- EMPTY -->
    <section class="no_notification" *ngIf="!(notifications$ | async).length">
      <div>{{ 'common.no_notification' | translate }}</div>
    </section>
    <!-- FULL -->
    <mat-accordion>
      <ebw-notification *ngFor="let notification of notifications$ | async" [notification]="notification"></ebw-notification>
    </mat-accordion>
  </div>
</mat-menu>
